import React, { useEffect, useState } from 'react';
import { Loading } from 'components/loading/Loading';
import FilePreviewer from 'react-file-previewer-v2';
import { deleteMedia } from 'services';
import { imageKitBaseURL } from 'components/ImageWrapper';
import { copyToClipboard } from 'utils';


const Document = (props) => {
  const { doc, onDocumentChange, onItemSelected } = props;

  const showFullScreen = (doc: any) => {
    window.open(doc.media?._url, '_blank');
  };

  const [loading, setLoading] = useState(false);

  const deleteDocument = async ({ objectId }) => {
    setLoading(true);
    try {
      await deleteMedia(objectId);
      onDocumentChange && onDocumentChange();
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const getOverLayButtons = () => {
    return (
      <>
        <div className="fullscreen-icon d-inline" style={{ zIndex: 1, cursor: 'pointer' }}>
          <i className="fa fa-arrows-alt pointer" onClick={() => showFullScreen(doc)} />
        </div>
        <div className='edit-icon d-inline' style={{ zIndex: 1, cursor: 'pointer' }}>
          <i className="fa fa-edit pointer" onClick={() => onItemSelected && onItemSelected(doc)} />
        </div>
        <div className='copy-icon d-inline' style={{ zIndex: 1, cursor: 'pointer' }}>
          <i
            className={`fa fa-files-o pointer`}
            onClick={() => copyToClipboard(`${imageKitBaseURL}/${doc?.media?._name}`)}
          />
        </div>
        <div className="delete-icon fullscreen-icon d-inline" style={{ zIndex: 1, cursor: 'pointer' }}>
          <i className="fa fa-trash pointer" onClick={() => deleteDocument(doc)} />
        </div>
      </>
    );
  };

  return (<>
    <div key={doc.objectId}>
      <div className="uploaded-image-container">
        {getOverLayButtons()}
        <div className="uploaded-image-list">
          <FilePreviewer
            file={{ url: doc.media?._url }}
          />
        </div>
        {loading && <Loading type="mini" />}
      </div>
    </div>
  </>);
};

export { Document };